import { themedStyled } from 'common/styles/styletron.theme';

export const Button = themedStyled<'div', { isError: boolean }>(
  'div',
  ({ $theme, isError }) => ({
    display: 'flex',
    alignItems: 'center',
    paddingTop: '2px',
    paddingRight: '2px',
    paddingBottom: '2px',
    paddingLeft: '2px',
    border: 'none',
    marginLeft: '-2px',
    fontWeight: '700',
    marginRight: '-2px',
    cursor: 'pointer',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
    backgroundColor: 'transparent',
    color: $theme.colors.primaryDark,
    WebkitTextFillColor: $theme.colors.primaryDark,
    ':hover': {
      background: isError
        ? $theme.colors.redLightest
        : $theme.colors.primaryLightest,
    },
    ':focus': {
      outlineColor: isError
        ? $theme.colors.redDefault
        : $theme.colors.primaryDefault,
    },
    ':disabled': {
      backgroundColor: 'transparent',
      color: '#A7A7A7',
      WebkitTextFillColor: '#A7A7A7',
    },
  }),
);

export const IconContainer = themedStyled('div', {
  height: '36px',
  width: '36px',
  paddingTop: '4px',
  marginBottom: '16px',
  justifyContent: 'center',
  display: 'flex',
});
